import React from 'react'
import { RegisterOptions } from 'react-hook-form'
import { TextField } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField/TextField'

import { baseColor } from '#/shared/lib/constants/colors'

export const styleInputWithoutBorderFocus = {
	'& .MuiOutlinedInput-root:hover': {
		'& > fieldset': {
			borderColor: baseColor,
		},
	},
	'& .MuiOutlinedInput-root:not(:hover)': {
		'& > fieldset': {
			borderColor: 'none',
		},
	},
}

export const InputStyleLight = {
	borderRadius: '15px',
	marginTop: 0,
	paddingTop: 0,
	paddingBottom: 0,
	...styleInputWithoutBorderFocus,
	'& label': { color: '#8853FA' },
	backgroundColor: 'transparent',
	'& .Mui-disabled': {
		backgroundColor: '#151518',
		color: 'red',
	},
	input: {
		color: '#272727',
		'&::placeholder': {
			fontSize: '15px',
			color: '#80808E',
			fontWeight: 400,
		},
		'& .Mui-disabled': {
			webkitTextFillColor: 'red',
			backgroundColor: '#151518',
			color: 'red !important',
		},
	},
	fieldset: {
		borderRadius: '15px',
		border: '2px solid #d5d7db',
	},
}

export const InputStyleDark = {
	...InputStyleLight,
	backgroundColor: '#151518',
	input: {
		color: '#E1E1E1',
		'&::placeholder': {
			fontSize: '15px', // Например, уменьшим размер шрифта плейсхолдера
			color: '#80808E', // Изменим цвет плейсхолдера
		},
	},
	fieldset: {
		border: '2px solid #40404E',
		borderRadius: '15px',
	},
}

export const InputStyleSmallLight = {
	...InputStyleLight,
	paddingBlock: '0px',
	input: {
		paddingBlock: '10px',
		fontSize: '14px !important',
	},
}

export const InputStyleSmallDark = {
	...InputStyleDark,
	paddingBlock: '0px',
	input: {
		color: '#E1E1E1',
		paddingBlock: '10px',
		fontSize: '14px !important',
	},
}

type FormStateProps = {
	name?: string
	option?: RegisterOptions
}
export const Input = (props: TextFieldProps & FormStateProps) => {
	return <TextField fullWidth sx={{ ...InputStyleDark }} {...props} />
}
